import { render, staticRenderFns } from "./MediakitCollectionCard.vue?vue&type=template&id=aa55d26c&scoped=true&"
import script from "./MediakitCollectionCard.vue?vue&type=script&lang=js&"
export * from "./MediakitCollectionCard.vue?vue&type=script&lang=js&"
import style0 from "./MediakitCollectionCard.vue?vue&type=style&index=0&id=aa55d26c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa55d26c",
  null
  
)

export default component.exports